import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./youtubecard.css";

const YoutubeCard = () => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const videoRefs = useRef([]);

  const playVideo = (index, videoSrc) => {
    setCurrentVideo(index);
    videoRefs.current[index].src = videoSrc;
    videoRefs.current[index].play();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const items = [
    {
      videoSrc: "https://youtu.be/XhL_G1dXcWE?si=OVVQesbFH2zvxgqf",
      altText: "Video 1",
      title: "Boost Your English for Work Meetings",
      description:
        "Enhance your communication skills for work meetings, focusing on making clear points, asking questions, and participating effectively in discussions.",
    },
    {
      videoSrc: "https://youtu.be/IjZ9-7Vf3FM?si=g2ZVqW176rWoUTvx",
      altText: "Video 2",
      title: "Speaking English in Meetings",
      description:
        "Improve your ability to speak confidently in meetings, including expressing opinions, offering ideas, and responding to colleagues' suggestions.",
    },
    {
      videoSrc: "https://youtu.be/BtZwRTFsiMc?si=AemneKyQyPR6a8ui",
      altText: "Video 3",
      title: "Speaking English at Work",
      description:
        "Develop your ability to communicate effectively at work, from interacting with coworkers and clients to discussing projects and handling professional tasks.",
    },
    {
      videoSrc: "https://youtu.be/wNLoujhjSzk?si=DqC38pBA43430v6C",
      altText: "Video 4",
      title: "Master English when You're into Business",
      description:
        "Master English for success in business, focusing on key communication skills for professional interactions, negotiations, and presentations.",
    },
    {
      videoSrc: "https://youtu.be/SLylz2tpHCs?si=P3Zi1HDC6SeHkbiC",
      altText: "Video 5",
      title: "Fluent Pronunciation, Business Success!",
      description:
        "Achieve fluent pronunciation to enhance your business success, helping you communicate clearly and confidently in professional settings.",
    },
  ];
  const getYouTubeID = (url) => {
    const match = url.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    );
    return match ? match[1] : null;
  };

  return (
    // <div className="md:mx-20 sm:mx-4 gap-12 mb-10 cursor-pointer bg-red-500 text-center">
    //   <Slider {...settings}>
    //     {items.map((item, index) => (
    //       <div key={index} className="carousel-item">
    //         <div
    //           className="video-thumbnail"
    //           onClick={() => playVideo(index, item.videoSrc)}
    //         >
    //           <video controls>
    //             <source src={item.videoSrc} type="video/mp4" />
    //             Your browser does not support the video tag.
    //           </video>

    //           <h5 className="carousel-title">{item.title}</h5>
    //           <p className="carousel-description">{item.description}</p>
    //         </div>
    //       </div>
    //     ))}
    //   </Slider>
    // </div>
    <div className="md:mx-20 sm:mx-4 mx-2 gap-6 mb-10 cursor-pointer text-center">
      <Slider {...settings}>
        {items.map((item, index) => (
          <div key={index} className="carousel-item">
            <div
              className="video-thumbnail p-4 sm:p-6"
              onClick={() => playVideo(index, item.videoSrc)}
            >
              <iframe
              className='w-full h-auto rounded-lg'
              src={`https://www.youtube.com/embed/${getYouTubeID(item.videoSrc)}`}
              title={item.title}
              allowFullScreen
              >

              </iframe>

              <h5 className="carousel-title text-sm sm:text-lg font-semibold mt-4">
                {item.title}
              </h5>
              <p className="carousel-description text-xs sm:text-base mt-2">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default YoutubeCard;
